export enum KeywordReasonType {
  DEFAULT_KEYWORD = "DEFAULT_KEYWORD",
  PURCHASED_BY_PLAYER = "PURCHASED_BY_PLAYER",
  ASSIGNED_BY_PLAYER = "ASSIGNED_BY_PLAYER",
  ADDED_BY_KEYWORD = "ADDED_BY_KEYWORD",
  ADDED_BY_CURSED_ARTEFACT = "ADDED_BY_CURSED_ARTEFACT",
}
